(function () {
    'use strict';

    angular.module('swif.reservations')
    .service('openresaRequestService', openresaRequestService);

    function openresaRequestService($q, $location, swif, openresaRightsService, openresaBookingService, openresaRecurrenceService) {
        'ngInject';
    	var service = {};
    	service.collectionName = 'reservationRequests';
    	service.content_type = 'reservationRequest';

        // collections (fetch / init) specific methods
    	service.getCollection = getCollection;
	    service.initCollection = initCollection;
        service.addOnlyContractsFilter = addOnlyContractsFilter;
        service.resolveData = resolveData;

        // models (fetch / init) specific methods
        service.init = init;
	    service.fetch = fetch;
        service.fetchSlowFields = fetchSlowFields;

        // model save specific methods
	    service._saveDelayed = _saveDelayed;
        service._preSaveBooking = _preSaveBooking;
        service._preSaveRecurrence = _preSaveRecurrence;
        service._saveRecurrences = _saveRecurrences;
        service._saveBookings = _saveBookings;
        service._deleteBookings = _deleteBookings;
        service._deleteRecurrences = _deleteRecurrences;
        service._preSanitizeRequest = _preSanitizeRequest;
        service.save = save;

        // form specific methods
        service.getFilters = getFilters;
        service.getCountFilter = getCountFilter;
        service.linkRecurrenteBookings = linkRecurrenteBookings;

        // actions specific methods
	    service.preModal = preModal;
	    service.preValidate = preValidate;
	    service.callback = callback;

	    function getCollection () {
            return swif.collections.getCollection(service.collectionName);
        }

        function initCollection (filter, options) {
            filter = service.addOnlyContractsFilter(filter || {});
            swif.data.sortOn(filter, 'id', 'DESC');
            return swif.collections.createOrUpdate(
                service.collectionName,
                service.content_type,
                filter,
                {location: true}
            );
        }

        function addOnlyContractsFilter (filter) {
            if (!filter) {
                filter = {};
            }
            var user = swif.user.getAuthenticatedUserData();
            var managedBookables = user.managed_bookables || [];
            var ability = openresaRightsService.getUserAbility();
            // if(!ability.is.manager && !ability.is.agent) {
            // @TODO: refactor this role to be an atomic right, not a role anymore
            if(!ability.is.agent) {
                if (!_.isEmpty(managedBookables)) {
                    var field = 'booking_ids.reservation_line.product_id';
                    swif.data.addExtraFilter(filter, 'managerOnly', '|');
                    swif.data.addExtraFilter(filter, 'managerOnly', '|');
                    swif.data.addExtraFilter(filter, 'managerOnly', field, 'in', managedBookables);
                    // every manager can see a request without any line
                    swif.data.addExtraFilter(filter, 'managerOnly', 'booking_ids.reservation_line', '=', false);
                }
                swif.data.addExtraFilter(filter, 'claimerOnly', 'partner_invoice_id.user_id', '=', user.id);
            }
            return filter;
        }

         function resolveData () {
            return swif.route.check()
            .then(function () {
                return service.initCollection().then(function(collection) {
                    var data = {};
                    data.reservationRequests = collection;
                    return data;
                });
            });
        }

        // prepare a new model Object (new record or before fetching record)
        function init (model) {
            if (!model) {
                model = {};
            }
            var user = swif.user.getAuthenticatedUserData();
            var defaults = {
                bookings: [],
                recurrences: [],
                _selectedBooking: {},
                deletedBookings: [],
                deletedRecurrences: [],
                name: '',
                state: 'draft',
                partner_id: user.partner_id,
                partner_invoice_id: user.address_id
            };
            _.defaults(model, defaults);
            // ensure content_type of the record
            model._type = service.content_type;
            return model;
        }

        // fetch data under a request model (recurrences and bookings)
        function fetch (model, bookingsFilter, recurrencesFilter) {
            // fetch bookings
            var filter = angular.copy(bookingsFilter || {});
            swif.data.addFilter(filter, 'request_id', '=', model.id);
            var options = {
                limitPerPage: 0
            };
            return openresaBookingService.initCollection(filter, options)
            .then(function (coll) {
                model.bookings = coll.items;
                // then, fetch recurrences
                var filter2 = angular.copy(recurrencesFilter || {});
                swif.data.addFilter(filter2, 'request_order_id', '=', model.id);
                return openresaRecurrenceService.initCollection(filter2, options)
                .then(function (coll2) {
                    model.recurrences = coll2.items;
                    return model;
                });
            });
        }

        function fetchSlowFields (model, filter) {
            return $q.all([
                openresaBookingService.fetchSlowFields(model.bookings, filter),
                openresaRecurrenceService.fetchSlowFields(model.recurrences, filter)
            ]);
        }

        // return a promise, resolved when ALL the save are done
        // @param bookings: Array of items to save
        // @param fnct: Function used to save each item
        function _saveDelayed (bookings, fnct) {
            var i = 0;
            // recursive method, save each element on the list, on at a time, as a queue system
            function saveHandler (retValue) {
                if (!retValue) {
                    retValue = $q.defer();
                }
                var booking = bookings[i];
                // while it remains bookings to save, recursively call itself
                if (booking) {
                    // increment counter for the next recursive call
                    i++;
                    fnct(booking).then(function () {
                        saveHandler(retValue);
                    }, function () {
                        // @TODO: (CHECK) should you stop here the defers if an error occurred ?
                        saveHandler(retValue);
                    });
                } else {
                    retValue.resolve();
                }
                return retValue.promise;
            }
            return saveHandler();
        }

        function _preSaveBooking (request, booking) {
            //Event needs to keep booking name as well
            if (!booking.name) {
                booking.name = request.name;
            }
            if (!booking.note){
                booking.note = request.note;
            }
            booking.request_id = [request.id, request.name];
            if (!booking.event_type_id) {
                booking.event_type_id = request.booking_type_id;
            }
            // remove the state from the booking,
            // in the request edition, this is the server task to handle the state
            // delete booking.state;
            return booking;
        }

        function _preSaveRecurrence (request, recurrence) {
            service._preSaveBooking(request, recurrence);
            recurrence.request_order_id = recurrence.request_id;
            delete recurrence.state;
            return recurrence;
        }

        function _saveRecurrences (model, recurrences) {
            var ret = $q.when(true);
            var todo = [];
            _.forEach(recurrences, function (recurrence) {
                if (recurrence.fetched || !recurrence.id) {
                    service._preSaveRecurrence(model, recurrence);
                    todo.push(recurrence);
                }
            });
            if (!_.isEmpty(todo)) {
                ret = service._saveDelayed(todo, openresaBookingService.save);
            }
            return ret;
        }

        function _saveBookings (model, bookings) {
            var ret = $q.when(true);
            var todo = [];
            _.forEach(bookings, function (booking) {
                if (booking.fetched || !booking.id) {
                    service._preSaveBooking(model, booking);
                    todo.push(booking);
                }
            });
            if (!_.isEmpty(todo)) {
                ret = service._saveDelayed(todo, openresaBookingService.save);
            }
            return ret;
        }

        function _deleteBookings (bookings) {
            var ids = [];
            _.forEach(bookings, function (booking) {
                if (booking.id) {
                    ids.push(booking.id);
                }
            });
            return swif.data.unlink('reservation', ids);
        }

        function _deleteRecurrences (recurrences) {
            var ids = [];
            _.forEach(recurrences, function (recurrence) {
                if (recurrence.id) {
                    ids.push(recurrence.id);
                }
            });
            return swif.data.unlink('recurrenteReservation', ids);
        }

        function _preSanitizeRequest (request) {
            // delete all known related fields (otherwise, may result in ORM rights error)
            delete request.contact_phone;
            delete request.partner_type;
        }

        function _saveBookingStates (request) {
            // if some recurrence has been modified (not just created),
            // retrieve their occurrences not modified
            // (which won't be saved by themselves)
            // to save their (eventual) state changes
            // @TODO: should be done in openrea.requests.save() instead
            var toWrite = {
                active: [],
                waiting: [],
                inactive: []
            };
            var toWriteLines = {
                active: [],
                waiting: [],
                inactive: []
            };
            var defers = [];
            _.forEach(request.bookings, function (booking) {
                if (booking.recurrence) {
                    var recur = booking.recurrence;
                    var recurChanged = recur.id && recur.fetched && recur._occurrencesState;
                    var bookingNotChanged = !booking.fetched && booking.id && booking.state;
                    if (recurChanged && bookingNotChanged) {
                        if (booking.state) {
                            toWrite[booking.state].push(booking.id);
                            _.forEach(booking.lines, function (line) {
                                toWriteLines[booking.state].push(line.id);
                            });
                        }
                    }
                }
            });
            _.forOwn(toWrite, function (ids, state) {
                if (ids.length > 0) {
                    defers.push(swif.data.callKw(
                        'reservation',
                        'write',
                        [ids, {state: state}]
                    ));
                }
            });
            _.forOwn(toWriteLines, function (ids, state) {
                if (ids.length > 0) {
                    defers.push(swif.data.callKw(
                        'reservation_line',
                        'write',
                        [ids, {state: state}]
                    ));
                }
            });
            if (defers.length === 0) {
                return $q.when(true);
            }
            return $q.all(defers);
        }

        function save (model) {
            return syncRequest(model).then(function () {
                return _saveBookingStates(model).then(function () {
                    return service._deleteBookings(model.deletedBookings).then(function () {
                        return service._deleteRecurrences(model.deletedRecurrences).then(function () {
                            return service._saveRecurrences(model, model.recurrences).then(function () {
                                return service._saveBookings(model, model.bookings).then(function () {
                                    return true;
                                });
                            });
                        });
                    });
                });
            });
        }

        function syncRequest (request) {
            // swif.message.loading(request._loadings);
            var ret = null;
            service._preSanitizeRequest(request);
            if(request.id) {
                ret = swif.data.save(service.content_type, request.id, request);
            }
            else {
                ret = swif.data.create(service.content_type, request);
            }
            return ret.then(function (data) {
                // when creating a new reservation, set the id returned by the server
                if(!request.id) {
                    request.id = data.result;
                }
            });
        }

        function getFilters (model) {
            var partner_filter = {};
            var pafilter = {fields: ['name', 'complete_name', 'partner_id', 'is_active']};
            swif.data.addFilter(partner_filter, 'customer', '=', true);
            if(model.is_citizen){
                swif.data.addFilter(partner_filter, 'type_id.code', '=', 'PARTICULIER');
            }
            if (model.partner_invoice_id && !model.is_citizen) {
                var addressId = model.partner_invoice_id[0];
                swif.data.addFilter(partner_filter, 'address', '=', addressId);
            }
            // if user isn't MANAGER nor ACCUEIL, it can only access to its own partners
            var user = swif.user.getAuthenticatedUserData();
            var ability = openresaRightsService.getUserAbility();
            if(!ability.is.manager && !ability.is.agent) {
                swif.data.addFilter(partner_filter, 'address.user_id', '=', user.id);
                swif.data.addFilter(pafilter, 'user_id', '=', user.id);
            }

            if (model.partner_id) {
                swif.data.addFilter(pafilter, 'partner_id.id', '=', model.partner_id[0]);
            }
            swif.data.addFilter(pafilter, 'partner_id.customer', '=', true);

            var ret = {
                partner: partner_filter,
                partner_address: pafilter,
                resource: {}
                // resource: service._computeResourceFilter()
            };
            return ret;
        }

        function getCountFilter (currentFilter) {
            var countFilter = {};
            var infoFilter = angular.copy(currentFilter);
            swif.data.addFilter(
                infoFilter,
                'state',
                'in',
                ['remplir']
            );
            countFilter.info = infoFilter;

            var successFilter = angular.copy(currentFilter);
            swif.data.addFilter(
                successFilter,
                'state',
                'in',
                ['confirm']
            );
            countFilter.success = successFilter;
            return countFilter;
        }

        function linkRecurrenteBookings (model) {
            _.forEach(model.recurrences, function (recur) {
                _.forEach(model.bookings, function (elt) {
                    var rid = elt.recurrence_id ? elt.recurrence_id[0]: false;
                    if (recur.id === rid) {
                        elt.recurrence = recur;
                    }
                });
                openresaRecurrenceService.computeLastDate(model, recur);
            });
        }

        function preModal (data) {
            var collection = service.getCollection();
            if (data.action.id === 'add' && $location.path() !== '/reservations/reservations/planning_view') {
                if (collection) {
                    collection.preModal(data);
                }
            }
            if (data.action.id === 'attachments') {
                swif.attachment.attachmentPreModal(data, service.getCollection());
            }
            if (data.action.id === 'readonly') {
                data.model._readonly = true;
            }
        }

        function preValidate (data) {
            var deferred = null;
            var params = {};
            var collection = service.getCollection();
            if (data.action.id === 'print') {
                deferred = collection.preValidate(data);
            }
            if (_.contains(['add', 'edit', 'readwrite', 'manage_events'], data.action.id)) {
                deferred = service.save(data.model);
            } else if(_.contains(['cancel', 'confirm', 'refuse', 'done', 'delete'], data.action.id)) {
                params = {
                    send_invoicing: data.model.sendInvoice || false,
                    send_email: data.model.sendMail || false
                };
                // build *_note field, according the action to send to server
                var note = data.model.actionNote;
                if(data.action.id === 'delete') {
                    params.refuse_note = note;
                } else {
                    params[data.action.id + '_note'] = note;
                }
                if (data.action.id === 'confirm') {
                    // save states updated on the modal
                    params.booking_ids = [];
                    _.forEach(data.model.bookings, function (booking) {
                        var val = {state: booking.state, reservation_line: []};
                        _.forEach(booking.lines, function (line) {
                            val.reservation_line.push([1, line.id, {state: booking.state}]);
                        });
                        params.booking_ids.push([1, booking.id, val]);
                    });
                }
                if (data.action.id === 'done') {
                    // Create tasks if _tasks key is in the model
                    if (data.model._tasks && data.model._tasks.length) {
                        deferred = [];
                        let args = { tasks: data.model._tasks };
                        swif.data.callKw('task', 'create_reservation_request_tasks', [args]).then(function(res) {
                            swif.message.addInfo('Task(s) successfully created');
                        });
                    }
                }
                deferred = swif.data.save('reservationRequest', data.model.id, params).then(function () {
                    if(data.action.id === 'delete') {
                        return swif.data.unlink('reservationRequest', [data.model.id]);
                    } else {
                        return swif.data.execWorkflow(
                            'reservationRequest',
                            data.model.id,
                            data.action.id
                        );
                    }
                });
            } else if(_.contains(['submit', 'direct_submit'], data.action.id)) {
                var defers = [];
                defers.push(swif.data.execWorkflow(service.content_type, data.model.id, 'save'));
                defers.push(swif.data.callKw(service.content_type, 'notify_new', [data.model.id]));

                return $q.all(defers);
            }
            var msg = data.action.waitingText || 'Reservation update in progress';
            if(deferred) {
                swif.message.addDeferredMsg(msg, deferred);
            }
            return deferred;
        }

        function callback (error, data) {
            var msg;
            if (data.action.id === 'add') {
                msg = 'reservation created successfully';
            } else {
                msg = 'reservation saved successfully';
            }
            swif.message.addInfo(msg);
            var collection = service.getCollection();
            //try to make collection.fasterCallback work
            data.result = {data: data.model.id};
            // if the curent model is going to be added to the collection items (new item),
            // i pre-fill the 'resources' attribute, to prevent
            // reservation-resources directive to fetch 'resources 'from server,
            // as the faster callBack will already retrieve this data
            if (_.contains(['add', 'copy'], data.action.id)) {
                data.model.resources = {};
            }
            if (collection) {
                collection.fasterCallback(data);
            }

            if (!_.contains(swif.collection.defaultActionIds, data.action.id)){
                if (collection) {
                    collection.updateItem(data.model);
                }
            }
        }

    	return service;
    }

})();
